<template>
    <div>
        slide
    </div>
</template>

<script>
import ctrl from "./hotkey.js";
export default ctrl;
</script>